import {CpmCCustomerApiModel} from '../../models/c-common/cpmc-customer.api-model';
import {CpmCUserRoleApiModel} from '../../models/c-common/cpmc-user-role.api-model';

/**
 * Utils for class CpmCUserRoleApiModel
 */
export class CpmCUserRoleApiUtils {
    /**
     * Format a UserRoleOO8CPMApiModel name for display to add informations about the scope
     * @param userRole Input UserRole
     * @param customer Input Customer
     * @param isCustomerPOV Is from customer point of view?
     * @returns Formatted UserRole name
     */
    public static formatUserRoleName(
        userRole: CpmCUserRoleApiModel,
        customer: CpmCCustomerApiModel | undefined,
        isCustomerPOV: boolean
    ) {
        if (!userRole.multi_schema_tenant_uuid) return userRole.name + ' [Common]';

        if (!isCustomerPOV) {
            if (!customer) {
                return userRole.name + ' [??]';
            }

            return userRole.name + ' [Cust: ' + customer.name + ']';
        }

        return userRole.name;
    }
}
